import Image from 'next/legacy/image'

import Box from '@totallymoney/ui/components/Box'

interface CardPageImageProps {
    cmsImageUrl: string
    isPortraitImage: boolean
    name: string
}

const CardPageImage = ({
    name,
    cmsImageUrl,
    isPortraitImage,
}: CardPageImageProps) => {
    const imageDimensions = !isPortraitImage
        ? { width: 440, height: 280 }
        : { width: 280, height: 440 }

    return (
        <Box display="flex" width="100%">
            <Image
                src={cmsImageUrl}
                alt={`${name} credit card`}
                {...imageDimensions}
            />
        </Box>
    )
}

export default CardPageImage
